<div class="auth-page">
  <div
    class="auth-page__visual"
    [style.background-image]="'url(' + branding.loginVisual + ')'"
  >
    <div class="auth-page__visual-inner">
      <div class="auth-page__site-name">
        {{ branding.siteName }}
      </div>

      <div class="auth-page__footer-logo">
        <img
          class="auth-page__footer-logo-image"
          [src]="branding.logoFooter"
          alt=""
        />
      </div>
    </div>
  </div>

  <div class="auth-page__content">
    <div class="auth-page__content-inner">
      <div class="auth-page__form-wrap">
        <div
          *ngIf="step === 'login'"
          [formGroup]="loginForm"
          class="auth-card"
          [@formTransition]
        >
          <div class="auth-card__brand">
            <img
              class="auth-card__brand-logo"
              [src]="branding.logoMain"
              alt=""
            />
          </div>

          <div class="auth-card__title">Login</div>

          <div class="error-box" *ngIf="isLoginError">
            <mat-icon class="error-icon">error</mat-icon>
            <span>กรุณาลองใหม่อีกครั้ง</span>
          </div>

          <div class="auth-card__field">
            <div class="auth-card__label">Email</div>
            <mat-form-field appearance="outline" class="auth-card__control">
              <mat-label>Please Enter Email Or Username</mat-label>
              <input matInput formControlName="email" />
              <mat-icon matSuffix style="color: #b1b1b1">email</mat-icon>
            </mat-form-field>
          </div>

          <div class="auth-card__field">
            <div class="auth-card__label">Password</div>
            <mat-form-field appearance="outline" class="auth-card__control">
              <mat-label>Please Enter Password</mat-label>
              <input
                matInput
                formControlName="password"
                [type]="passwordInputType('login')"
              />
              <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="togglePassword('login', $event)"
                [attr.aria-label]="passwordAria('login')"
              >
                <mat-icon>{{ passwordIcon("login") }}</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <div class="auth-card__actions">
            <button
              mat-raised-button
              class="button-primary auth-card__submit"
              [disabled]="isSubmitting"
              (click)="login()"
            >
              Login
            </button>
          </div>

          <div class="auth-card__footer">
            <div></div>

            <div [matMenuTriggerFor]="languageMenu" class="auth-card__language">
              <mat-icon>language</mat-icon>
              <span>{{ selectedLanguageLabel }}</span>
              <mat-icon>arrow_drop_down</mat-icon>
            </div>

            <mat-menu #languageMenu="matMenu" class="profile-menu">
              <button
                mat-menu-item
                *ngFor="let language of languages"
                (click)="onSelectLanguage(language.value)"
              >
                {{ language.viewValue }}
              </button>
            </mat-menu>
          </div>
        </div>

        <div
          *ngIf="step === 'reset'"
          [formGroup]="resetForm"
          class="auth-card"
          [@formTransition]
        >
          <div class="auth-card__brand">
            <img
              class="auth-card__brand-logo"
              [src]="branding.logoMain"
              alt=""
            />
          </div>

          <div class="auth-card__title">Reset Password</div>

          <div class="error-box" *ngIf="isResetError">
            <mat-icon class="error-icon">error</mat-icon>
            <span>Reset Password Error</span>
          </div>

          <div class="auth-card__field">
            <div class="auth-card__label">New Password</div>
            <mat-form-field appearance="outline" class="auth-card__control">
              <mat-label>Please Enter New Password</mat-label>
              <input
                matInput
                formControlName="newPassword"
                [type]="passwordInputType('new')"
              />
              <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="togglePassword('new', $event)"
                [attr.aria-label]="passwordAria('new')"
              >
                <mat-icon>{{ passwordIcon("new") }}</mat-icon>
              </button>
            </mat-form-field>

            <mat-error
              *ngIf="
                resetForm.get('newPassword')?.invalid &&
                resetForm.get('newPassword')?.touched
              "
            >
              {{ getErrorMessage("reset", "newPassword") }}
            </mat-error>
          </div>

          <div class="auth-card__field">
            <div class="auth-card__label">Confirm Password</div>
            <mat-form-field appearance="outline" class="auth-card__control">
              <mat-label>Please Confirm Password</mat-label>
              <input
                matInput
                formControlName="confirmPassword"
                [type]="passwordInputType('confirm')"
              />
              <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="togglePassword('confirm', $event)"
                [attr.aria-label]="passwordAria('confirm')"
              >
                <mat-icon>{{ passwordIcon("confirm") }}</mat-icon>
              </button>
            </mat-form-field>

            <mat-error
              *ngIf="
                resetForm.hasError('passwordMismatch') &&
                resetForm.get('confirmPassword')?.touched
              "
            >
              รหัสผ่านไม่ตรงกัน
            </mat-error>
          </div>

          <div class="auth-card__actions">
            <button
              mat-raised-button
              class="button-primary auth-card__submit"
              [disabled]="isSubmitting"
              (click)="submitResetPassword()"
            >
              Save & Login
            </button>
          </div>

          <div class="auth-card__back">
            <button mat-button type="button" (click)="backToLogin()">
              Back
            </button>
          </div>
        </div>
      </div>

      <div class="auth-page__copyright">
        copyright 2021 © XTEN Technology Inc. all rights reserved
      </div>
    </div>
  </div>
</div>
